<nz-card class="header-card" nzSize="small">
  <div class="flex justify-start flex-wrap gap-0 xsm:gap-2">
    <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  </div>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xsm:!text-2xl my-0">{{ this.news.title }}</h2>
  </div>
</nz-card>

<nz-card class="!mt-4">
  <div class="flex justify-between items-start gap-8 flex-col md:flex-row">
    <div class="basis-[50%] w-full lg:basis-[45%] xl:basis-[35%]  h-[500px] relative">
      <img class="w-full rounded-lg h-full object-contain" alt="Image" (error)="onImageError($event)"
        [src]="this.news.thumbnail.url" />
    </div>
    <div class="basis-[50%] w-full lg:basis-[55%] xl:basis-[65%]">
      <h5
        class="text-[#441752] !text-[13px] xsm:!text-lg border-t-transparent border-r-transparent border-l-transparent pb-4 border-b border-solid border-[#D9D9D9]">
        {{ this.news.author }} | {{ formatDate(this.news.createdAt) }} |
        {{ this.news.readTime }} min read
      </h5>
      <p class="font-[400] mt-6 mb-3" [innerHTML]="serializeToHTML(this.news.content1)"></p>

      <div *ngIf="this.news.link" class="flex flex-row gap-1  mt-4 items-center flex-wrap">
        <p class="mb-0">Explore related articles for more information:</p>
        <a [href]="this.news.link" target="_blank"
          class="cursor-pointer text-[#B08D23] py-0 px-4 custom-link font-normal">Learn More</a>
      </div>

    </div>
  </div>
</nz-card>